<template>
  <UC :menus="menus"></UC>
</template>
<script>
import UC from '@/page/modules/uc/index'
export default {
  components: { UC },
  data () {
    return {
      menus: [{
        id: '0122',
        name: '我的课程',
        path: '/byl/uc/record',
        iconClass: 'icon_a'
      }, {
        id: '0131',
        name: '我的学时',
        path: '/byl/uc/lrecord',
        iconClass: 'icon_a'
      }, {
        id: '0123',
        name: '我的收藏',
        path: '/byl/uc/fav',
        iconClass: 'icon_b'
      }, {
        id: '0124',
        name: '我的考试',
        path: '/byl/uc/examination',
        iconClass: 'icon_c'
      }, {
        id: '0125',
        name: '我的报名',
        path: '/byl/uc/enroll',
        iconClass: 'icon_c'
      }, {
        id: '0126',
        name: '我的证书',
        path: '/byl/uc/certificate',
        iconClass: 'icon_d'
      }, {
        id: '0127',
        name: '我的消息',
        path: '/byl/uc/message',
        iconClass: 'icon_e'
      }, {
        id: '0128',
        name: '资料设置',
        path: '/byl/uc/set',
        iconClass: 'icon_f'
      }, {
        id: '0129',
        name: '我的订单',
        path: '/byl/uc/order',
        iconClass: 'icon_h'
      },{
        id: '0130',
        name: '我的开票',
        path: '/byl/uc/invoice',
        iconClass: 'icon_h'
      }]
    }
  }
}
</script>
<style lang="scss">
  .member_top { margin-top: 81px; }
</style>



// WEBPACK FOOTER //
// src/page/byl/uc/index.vue